export default __webpack_public_path__ + "static/media/step1_mail.9f0ad27a.png";